import { FunctionComponent, useId } from 'react'
import ReactTooltip from 'react-tooltip'
import styled from 'styled-components'
import { Icon } from 'utils'
export interface TooltipInterface {
  a11yText?: string
  iconColor?: string
  iconSize?: number
  parentClass?: string
  children?: React.ReactNode
}
export const Tooltip: FunctionComponent<TooltipInterface> = ({
  a11yText,
  children,
  iconColor,
  iconSize
}) => {
  const sizeOfIcon = iconSize ?? 20
  const buttonStyle = {
    marginTop: sizeOfIcon * 0.125,
    marginRight: sizeOfIcon * 0.25,
    marginLeft: sizeOfIcon * 0.25,
    width: `${sizeOfIcon}px`,
    height: `${sizeOfIcon}px`
  }

  const id = useId()

  return (
    <>
      <button
        type="button"
        data-tip
        data-for={id}
        className="p-0 cursor-pointer border-none"
        style={buttonStyle}
        data-event="click"
      >
        <Icon
          role="presentation"
          id="#circle-question-outline"
          fill={iconColor ?? '#007497'}
          height={sizeOfIcon}
          width={sizeOfIcon}
        />
        <span className="wc-hidden--visually">{a11yText}</span>
      </button>
      <ReactTooltipWCStyling
        id={id}
        place="bottom"
        effect="solid"
        type="light"
        aria-haspopup="true"
        role="tooltip"
        // delayHide={500}
        multiline={true}
        backgroundColor="#f3f3f3"
        border={false}
        arrowColor="#f3f3f3"
        scrollHide={true}
        resizeHide={true}
        clickable={true}
        globalEventOff="click"
      >
        {children}
      </ReactTooltipWCStyling>
    </>
  )
}

const ReactTooltipWCStyling = styled(ReactTooltip)`
  width: 100% !important;
  max-width: 200px !important;
  min-width: 200px !important;
  padding: 1rem !important;
  font-size: 1.4rem !important;
  box-shadow: 1px 1px 8px rgb(51 51 51 / 16%) !important;
  white-space: break-spaces !important;
  opacity: 1 !important;
`
